<div *ngIf="tmoUnlimitedRatePlans" class="m-t-lg">
  <h3 *ngIf="!hidePlansHeader" class="m-b-xl text-center">{{ aemContent?.tmoUnlmtRatePlans }}</h3>
  <div id="child-div" class="m-t-xl">
    <h6 class="sub-header">{{ aemContent?.unlimitedPlanHeading }}</h6>
  </div>
  <ul class="col-12 m-t-lg m-b-xl" id="featuresDesc" *ngIf="tooltipList.length > 0">
    <li *ngFor="let tooltip of tooltipList">
      {{ tooltip?.text }}
      <a id="tooltip-text" class="tooltip-i m-l-sm" aria-label="Clickable action">
        <tmo-tooltip [text]="tooltip?.tooltipText"></tmo-tooltip>
      </a>
    </li>
  </ul>
</div>
<div
  *ngIf="connectByTmobile"
  class="m-t-lg"
  [ngClass]="{
    'connect-banner': showConnect,
    'product-select-connect-banner': hidePlansHeader && showConnect,
  }"
>
  <ng-container *ngIf="!showConnect">
    <h3 *ngIf="!hidePlansHeader" class="text-center m-b-xl">{{ aemContent?.connectByTmo }}</h3>
  </ng-container>
  <ng-container *ngIf="showConnect">
    <h3
      *ngIf="hidePlansHeader && showConnect"
      class="text-center"
      [ngClass]="{ 'connect-theme': showConnect }"
    >
      {{ aemContent?.connectByTmoHeading }}
    </h3>
  </ng-container>
  <h3 *ngIf="showConnect" [ngClass]="{ 'connect-theme': showConnect }">
    {{ aemContent?.limitedPlanHeading }}
  </h3>
  <div id="child-div" class="m-t-xl m-b-xl">
    <h6 class="sub-header" *ngIf="!showConnect">{{ aemContent?.limitedPlanHeading }}</h6>
    <p class="w-80 m-t-md" *ngIf="!showConnect">{{ aemContent?.limitedPlanSubHeading }}</p>
    <p class="w-80" *ngIf="showConnect">{{ aemContent?.limitedPlanConnectSubHeading }}</p>
  </div>
  <div
    class="m-t-xl m-b-xxl row justify-content-center"
    *ngIf="displayConnectPlansRadioButton && plansDuration && plansDuration.length && aemContent"
  >
    <div
      class="col-xs-12 col-sm-12 col-md-12 col-lg-2 m-b-md"
      *ngFor="let planDuration of plansDuration"
    >
      <tmo-radio-button
        type="radio"
        name="co-radio_{{ planDuration?.periodLength }}"
        [values]="planDuration?.periodLength"
        [selectedValue]="selectedDuration"
        (onSelect)="handleRadioClickEvent($event)"
        >{{ planDuration?.periodLength }}-{{ planDuration?.periodLengthUnit | titlecase }}
        {{ aemContent?.plans }}</tmo-radio-button
      >
    </div>
  </div>
  <!-- <div class="m-t-xl m-b-xxl row justify-content-center">

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 m-b-md">
            <tmo-radio-button type="radio" name="co-radio_sample1" [values]="oneMonthConstant"
                [selectedValue]="selectedRadioBtn" (onSelect)="handleRadioClickEvent($event)"
                [id]="'tmo-radio-button-coradiosample1'">{{aemContent?.oneMonthsPlan}}</tmo-radio-button>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 m-b-md">
            <tmo-radio-button type="radio" name="co-radio_sample1" [values]="sixMonthConstant"
                [selectedValue]="selectedRadioBtn" (onSelect)="handleRadioClickEvent($event)"
                [id]="'tmo-radio-button-coradiosample1-2'">{{aemContent?.sixMonthsPlan}}</tmo-radio-button>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 m-b-md">
            <tmo-radio-button type="radio" name="co-radio_sample1" [values]="twelveMonthConstant"
                [selectedValue]="selectedRadioBtn" (onSelect)="handleRadioClickEvent($event)"
                [id]="'tmo-radio-button-coradiosample1-2'">{{aemContent?.twelveMonthsPlan}}</tmo-radio-button>
        </div>

    </div>-->
</div>
<div *ngIf="unltMintPlans" class="m-t-lg">
  <h3 *ngIf="!hidePlansHeader" class="m-b-xl text-center">{{ aemContent?.mintPlans }}</h3>
  <div id="child-div" class="m-t-xl">
    <h6 class="sub-header">{{ aemContent?.alwaysStayConnected }}</h6>
    <p class="m-t-md w-80">{{ aemContent?.tmobilePrepaidGivesYou }}</p>
  </div>
</div>
